/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-27 14:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { FormLayout, TextStyle, Link, Icon, Stack } from '@shopify/polaris';
import { Field } from 'redux-form';
import { compare } from 'compare-versions';
import { ExternalMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import { VISIBLE_TEMPLATE_SETTING_ELEMENT } from 'src/constants/shopify-integration';

import {
  ELEMENTS,
  ELEMENT_KEY_NAME
  // PRODUCT_RATING_DISPLAY_OPTIONS
} from 'src/constants/theme-settings';
// import { DropdownIndicator, styles } from './react-select-style';
import { PRODUCT_REVIEWS } from 'src/constants/integration';

type Props = {
  formValues: any,
  prefix: string,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductItemAdditionalInfoForm extends Component<ComposedProps> {
  state = {
    error: ''
  };

  isShowProductRating = () => {
    const { boostThemeLibName, templateVersion } = this.props;
    return (
      VISIBLE_TEMPLATE_SETTING_ELEMENT[boostThemeLibName] &&
      compare(
        templateVersion,
        VISIBLE_TEMPLATE_SETTING_ELEMENT[boostThemeLibName].PRODUCT_ITEM_ADDITIONAL_RATING,
        '>='
      )
    );
  };

  render() {
    const { i18n, formValues, currentAppReviewIntegration } = this.props;
    const keyFormValues = Object.keys(_.get(formValues, 'setting', {}));
    const keyRating = keyFormValues.find(key => key.includes(ELEMENT_KEY_NAME.RATING));
    const appRating = PRODUCT_REVIEWS.find(item => item.appName === currentAppReviewIntegration);

    const isEnableRating = _.get(formValues, `setting.${keyRating}.isEnable`);
    const isShowProductRating = this.isShowProductRating();
    // const formattedProductRatingDisplay = PRODUCT_RATING_DISPLAY_OPTIONS.map(item => ({
    //   label: i18n.translate(item.label),
    //   value: item.value
    // }));

    return (
      <FormLayout>
        <div className="form-section">
          {/* <div className="form-section__item">
            <Field
              name={`setting.${ELEMENTS.PRODUCT_INFORMATION_PRODUCT_TITLE}.isEnable`}
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.ShopifyIntegrationSettings.Elements.elementOption_ProductTitle'
              )}
            />
          </div> */}

          <div className="form-section__item">
            <Field
              name={`setting.${ELEMENTS.PRODUCT_INFORMATION_PRODUCT_VENDOR}.isEnable`}
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.ShopifyIntegrationSettings.Elements.elementOption_ProductVendor'
              )}
            />
          </div>

          {/* <div className="form-section__item form-section__item--medium-spacing">
            <Field
              name={`setting.${ELEMENTS.PRODUCT_INFORMATION_DESCRIPTION}.isEnable`}
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.ThemeSetting.Elements.elementOption_ProductDescription'
              )}
              anotherProps={{
                helpText: i18n.translate(
                  'AdminHTML.ShopifyIntegrationSettings.Form.productDescription_Note'
                )
              }}
            />
          </div> */}

          {isShowProductRating && (
            <div className="form-section__item form-section__item--medium-spacing">
              <Field
                name={`setting.${keyRating}.isEnable`}
                component={RenderCheckbox}
                label={i18n.translate(
                  'AdminHTML.ShopifyIntegrationSettings.Elements.elementOption_ProductRating'
                )}
                anotherProps={{
                  helpText: (
                    <span className="form-link">
                      <TextStyle variation="subdued">
                        {i18n.translate(
                          'AdminHTML.ShopifyIntegrationSettings.Form.productRating_UserGuide'
                        )}
                      </TextStyle>{' '}
                      <Link url={URL['ProductPriceThemeSetting']} external>
                        {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
                        <Icon source={ExternalMinor} color="base" />
                      </Link>
                      <span style={{ color: '#2C6ECB' }}>.</span>
                    </span>
                  )
                }}
              />
            </div>
          )}

          {isShowProductRating && isEnableRating && (
            <>
              {/* <div className="form-section__item form-section__item--medium-spacing">
                <Field
                  name={`setting.${keyRating}.displayOptions`}
                  label={i18n.translate(
                    'AdminHTML.ShopifyIntegrationSettings.Form.productRating_DisplayOption_Title'
                  )}
                  options={formattedProductRatingDisplay}
                  component={RenderSelect2}
                  components={{ DropdownIndicator }}
                  styles={styles}
                  isSearchable={false}
                />
              </div> */}

              <div className="form-section__item form-section__item--medium-spacing">
                <div className="form-title">
                  <span style={{ marginRight: '6px', fontWeight: 600 }}>
                    {i18n.translate('AdminHTML.ThemeSetting.Form.productRating_InstalledApp')}
                  </span>
                </div>
                {appRating ? (
                  <div style={{ marginTop: '8px' }}>
                    <Stack alignment="center" spacing="tight">
                      <div className="icon-app-rating">
                        <img src={appRating.smallIcon} alt="icon" />
                      </div>
                      <p>{i18n.translate(appRating.name)}</p>
                    </Stack>
                  </div>
                ) : (
                  <div style={{ marginTop: '8px', color: '#6D7175' }}>
                    <span>
                      {i18n.translate(
                        'AdminHTML.ShopifyIntegrationSettings.Form.productRating_Guide1'
                      )}
                    </span>{' '}
                    <span>
                      {i18n.translate(
                        'AdminHTML.ShopifyIntegrationSettings.Form.productRating_Guide2',
                        {
                          t: (
                            <span className="form-link">
                              <Link
                                removeUnderline
                                onClick={() => {
                                  history.push(routes.integration.view());
                                }}>
                                <span style={{ textDecoration: 'underline' }}>
                                  {i18n.translate(
                                    'AdminHTML.ShopifyIntegrationSettings.Form.productRating_ProductReviews'
                                  )}
                                </span>
                                <Icon source={ExternalMinor} color="base" />
                                <span style={{ color: '#2C6ECB' }}>.</span>
                              </Link>
                            </span>
                          )
                        }
                      )}
                    </span>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ProductItemAdditionalInfoForm);
